import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { useLanguage } from '../hooks/useLanguage';
export function TermsPage() {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  return <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-2944">
      <Navbar data-id="element-2945" />

      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-2946">
        <Link to="/" className="inline-flex items-center gap-2 text-[#4f1964] hover:text-[#3d1350] mb-8 transition-colors" data-id="element-2947">
          <ArrowLeft className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} data-id="element-2948" />
          <span data-id="element-2949">{isRTL ? 'العودة للرئيسية' : 'Back to Home'}</span>
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-2950">
          <div className="flex items-center gap-4 mb-8" data-id="element-2951">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-2952">
              <FileText className="w-8 h-8 text-[#4f1964]" data-id="element-2953" />
            </div>
            <div data-id="element-2954">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-2955">
                {isRTL ? 'شروط الخدمة' : 'Terms of Service'}
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-2956">
                {isRTL ? 'آخر تحديث: يناير 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-2957">
            {isRTL ? <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2958">
                  قبول الشروط
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2959">
                  باستخدام منصة Operines، فإنك توافق على الالتزام بشروط الخدمة
                  هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام
                  خدماتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2960">
                  الفترة التجريبية المجانية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2961">
                  نقدم فترة تجريبية مجانية مدتها <strong data-id="element-2962">7 أيام</strong> لجميع
                  المستخدمين الجدد. خلال هذه الفترة، يمكنك الوصول إلى جميع ميزات
                  المنصة دون أي رسوم. بعد انتهاء الفترة التجريبية، ستحتاج إلى
                  الاشتراك في إحدى خططنا المدفوعة لمواصلة استخدام الخدمة.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2963">
                  استخدام الخدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2964">
                  أنت توافق على:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2965">
                  <li data-id="element-2966">استخدام المنصة للأغراض القانونية فقط</li>
                  <li data-id="element-2967">تقديم معلومات دقيقة وكاملة عند التسجيل</li>
                  <li data-id="element-2968">الحفاظ على أمان حسابك وكلمة المرور</li>
                  <li data-id="element-2969">عدم إساءة استخدام الخدمة أو محاولة اختراقها</li>
                  <li data-id="element-2970">الامتثال لجميع القوانين واللوائح المعمول بها</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2971">
                  الملكية الفكرية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2972">
                  جميع المحتويات والمواد والبرمجيات المتاحة على منصة Operines هي
                  ملكية حصرية لشركة Operines ومحمية بموجب قوانين حقوق النشر
                  والملكية الفكرية.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2973">
                  الدفع والفواتير
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2974">
                  بعد انتهاء الفترة التجريبية، سيتم تحصيل رسوم الاشتراك وفقًا
                  للخطة التي اخترتها. جميع الرسوم غير قابلة للاسترداد ما لم ينص
                  على خلاف ذلك صراحةً.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2975">
                  إنهاء الخدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2976">
                  نحتفظ بالحق في تعليق أو إنهاء حسابك في أي وقت إذا انتهكت هذه
                  الشروط أو انخرطت في سلوك غير قانوني أو ضار.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2977">
                  إخلاء المسؤولية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2978">
                  يتم توفير الخدمة "كما هي" دون أي ضمانات من أي نوع. نحن لا نضمن
                  أن الخدمة ستكون خالية من الأخطاء أو متاحة دون انقطاع.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2979">
                  تحديد المسؤولية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2980">
                  لن تكون Operines مسؤولة عن أي أضرار غير مباشرة أو عرضية أو
                  خاصة أو تبعية ناتجة عن استخدام أو عدم القدرة على استخدام
                  الخدمة.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2981">
                  التغييرات على الشروط
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2982">
                  نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطارك بأي
                  تغييرات جوهرية عبر البريد الإلكتروني أو من خلال المنصة.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2983">
                  الاتصال بنا
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2984">
                  إذا كانت لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا
                  على:
                  <br data-id="element-2985" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2986">
                    hello@operines.ai
                  </a>
                </p>
              </> : <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2987">
                  Acceptance of Terms
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2988">
                  By using the Operines platform, you agree to be bound by these
                  Terms of Service. If you do not agree to these terms, please
                  do not use our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2989">
                  Free Trial Period
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2990">
                  We offer a <strong data-id="element-2991">7-day free trial</strong> for all new
                  users. During this period, you can access all platform
                  features at no cost. After the trial ends, you will need to
                  subscribe to one of our paid plans to continue using the
                  service.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2992">
                  Use of Service
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2993">
                  You agree to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2994">
                  <li data-id="element-2995">Use the platform for lawful purposes only</li>
                  <li data-id="element-2996">
                    Provide accurate and complete information when registering
                  </li>
                  <li data-id="element-2997">Maintain the security of your account and password</li>
                  <li data-id="element-2998">Not misuse the service or attempt to hack it</li>
                  <li data-id="element-2999">Comply with all applicable laws and regulations</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3000">
                  Intellectual Property
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3001">
                  All content, materials, and software available on the Operines
                  platform are the exclusive property of Operines and protected
                  by copyright and intellectual property laws.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3002">
                  Payment and Billing
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3003">
                  After the trial period ends, subscription fees will be charged
                  according to your chosen plan. All fees are non-refundable
                  unless explicitly stated otherwise.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3004">
                  Service Termination
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3005">
                  We reserve the right to suspend or terminate your account at
                  any time if you violate these terms or engage in illegal or
                  harmful behavior.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3006">
                  Disclaimer
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3007">
                  The service is provided "as is" without warranties of any
                  kind. We do not guarantee that the service will be error-free
                  or available without interruption.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3008">
                  Limitation of Liability
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3009">
                  Operines shall not be liable for any indirect, incidental,
                  special, or consequential damages arising from the use or
                  inability to use the service.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3010">
                  Changes to Terms
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3011">
                  We reserve the right to modify these terms at any time. You
                  will be notified of any material changes via email or through
                  the platform.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3012">
                  Contact Us
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3013">
                  If you have any questions about these Terms of Service, please
                  contact us at:
                  <br data-id="element-3014" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-3015">
                    hello@operines.ai
                  </a>
                </p>
              </>}
          </div>
        </motion.div>
      </div>
    </div>;
}